module.exports = __webpack_public_path__ + "static/assets/35fed5da5aff896f6ea9d5d3ffc06c05.gif";